import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import SearchForm from "./SearchForm";
import { useState } from "react";
import styles from "./styles.module.scss";
import UsagesList from "./UsagesList";
import { ReactComponent as LogoWithBlackTxt } from "./logoWithBlackText.svg";

const Banner = () => {
  const navigate = useNavigate();
  const [t] = useTranslation("global");
  const [selectedUsage, setSelectedUsage] = useState(null);

  return (
    <section className={styles.banner}>
      <div className={`${styles.bannerContainer} pageContainer`}>
        <LogoWithBlackTxt
          className={styles.logoo}
          style={{ backgroundColor: "transparent" }}
        />{" "}
        <h1
          className={styles.heading}
          dangerouslySetInnerHTML={{ __html: t("slider.motto") }}
        />
        <p
          className={styles.text}
          dangerouslySetInnerHTML={{ __html: t("slider.subtext") }}
        />
        <SearchForm
          selectedUsage={selectedUsage}
          onUsageChange={setSelectedUsage}
        />
        <h2
          className={styles.spacesHeading}
          dangerouslySetInnerHTML={{ __html: t("slider.spacesText") }}
        />
        <UsagesList onUsageSelect={setSelectedUsage} />
      </div>
    </section>
  );
};

export default Banner;
